import {appApi} from "api/AppApi";

export default {
  install(Vue) {
    Vue.prototype.$api = appApi;
  }
};
